module.exports = __webpack_public_path__ + "static/media/banner-img-why-us.1705ed14.png";